/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getPublicAchievementEarlyRequestRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementPublicRpc',
  rpcName: 'getPublicAchievement',
  auth: 'external',
  fingerprint: 'IlAHR304DaXrzz933dMqCZEAXm2HbnMQ',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};